export const MY_TEAM_WIDGET_KEY = 'my-team';
export const RICH_TEXT_WIDGET_KEY = 'rich-text';
export const PERSON_LISTS_BY_DATE_WIDGET_KEY = 'person-lists-by-date';
export const DEFAULT_WIDGET_LAYOUT_ID = 'default';

export const AVATAR_SIZE = 50;
export const AVATAR_MARGIN_RIGHT = 8;
export const AVATAR_MARGIN_BOTTOM = 12;

export const MAX_PAGE_WIDTH = 1296;
export const UPDATE_FREQUENCY = {
  daily: 'today',
  weekly: 'this week',
  monthly: 'this month',
};

export const WIDGET_INFO = {
  [MY_TEAM_WIDGET_KEY]: {
    name: 'My Team',
    type: MY_TEAM_WIDGET_KEY,
  },
  [RICH_TEXT_WIDGET_KEY]: {
    name: 'Rich Text',
    type: RICH_TEXT_WIDGET_KEY,
  },
  [PERSON_LISTS_BY_DATE_WIDGET_KEY]: {
    name: 'Person Lists by Date',
    type: PERSON_LISTS_BY_DATE_WIDGET_KEY,
  },
};
